import { queryOptions } from '@tanstack/react-query'
import { unwrap } from '../../lib/api/client'
import {
  type CaseSatisfactionOut,
  type CustomerSatisfactionOut,
  caseSatisfactionApiV1SatisfactionCasesCaseIdGet,
  customerSatisfactionApiV1SatisfactionCustomersCustomerIdGet,
  type SatisfactionReportOut,
  satisfactionReportApiV1SatisfactionReportGet,
} from '../../lib/api/generated'

export const satisfactionCaseQuery = (caseId: string) =>
  queryOptions({
    queryKey: ['case', caseId, 'satisfaction'],
    queryFn: ({ signal }): Promise<CaseSatisfactionOut> =>
      unwrap(caseSatisfactionApiV1SatisfactionCasesCaseIdGet({ path: { case_id: caseId }, signal })),
    staleTime: 30_000,
  })

export const customerSatisfactionQuery = (customerId: string) =>
  queryOptions({
    queryKey: ['customer', customerId, 'satisfaction'],
    queryFn: ({ signal }): Promise<CustomerSatisfactionOut> =>
      unwrap(customerSatisfactionApiV1SatisfactionCustomersCustomerIdGet({ path: { customer_id: customerId }, signal })),
    staleTime: 60_000,
  })

export const satisfactionReportQuery = () =>
  queryOptions({
    queryKey: ['satisfaction', 'report'],
    queryFn: ({ signal }): Promise<SatisfactionReportOut> => unwrap(satisfactionReportApiV1SatisfactionReportGet({ signal })),
    staleTime: 30_000,
  })

export const canSeeSatisfactionReport = (role: string | null | undefined): boolean => role === 'manager' || role === 'cover'
